<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/d7ulDE/tc-custom/9781439680032.jpg?1719575726613" alt="This image is the cover for the book Pennsylvania Boxing Hall of Fame, Images of Sports"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Pennsylvania Boxing Hall of Fame, Images of Sports
      </h1>
      <p class="bookDescription body article font2">
        <p>The Pennsylvania Boxing Hall of Fame (PABHOF) was established in 1958 to honor the elite performers of the state's boxing history. The first five-person class of inductees included ring legends Billy Conn, Harry Greb, Tommy Loughran, Philadelphia Jack O'Brien, and Lew Tendler. The PABHOF continued to induct outstanding participants of the sport who either hailed from the state or had an impact on the Pennsylvania boxing story. By 2023, the list of honorees numbered 438 and included champions, contenders, club fighters, trainers, managers, promoters, cutmen, and other key members of the boxing community. <br/> John DiSanto is a boxing historian and writer. He coauthored the books Boxing in Atlantic City and Grace and Grit: Boxing at Shuler's Gym . DiSanto, the founder and editor of PhillyBoxingHistory.com, is a New Jersey Boxing Hall of Famer and is the chairman of the PABHOF. For this work, he has compiled photographs and profiles of many noteworthy PABHOF members as well as a complete listing of every person inducted from 1958 to 2023.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        John DiSanto
      </h2>
      
      <p class="authorDescription body article">John DiSanto is a boxing historian and writer. He coauthored the books Boxing in Atlantic City and Grace and Grit: Boxing at Shuler's Gym . DiSanto, the founder and editor of PhillyBoxingHistory.com, is a New Jersey Boxing Hall of Famer and is the chairman of the PABHOF. For this work, he has compiled photographs and profiles of many noteworthy PABHOF members as well as a complete listing of every person inducted from 1958 to 2023.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Arcadia Publishing
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?d3241402